import AssignmentsPage from './AssignmentsPage.container';

export default AssignmentsPage;
